import { render } from "./ButtonHeader.vue?vue&type=template&id=13bd7146&scoped=true"
import script from "./ButtonHeader.vue?vue&type=script&lang=js"
export * from "./ButtonHeader.vue?vue&type=script&lang=js"

import "./ButtonHeader.vue?vue&type=style&index=0&id=13bd7146&scoped=true&lang=css"

import exportComponent from "/builds/platform/frontend/side_panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13bd7146"]])

export default __exports__